import React from 'react';
import '../components/grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const SenseverbsExplanation = () => {
  return (
    <div className="grammar-explanation">
      
      <h2><FaBookOpen /> Sense Verbs: Describing Appearance and Perception</h2>

      <p>
       <FaLightbulb /> Sense verbs like <strong>look</strong>, <strong>sound</strong>, <strong>feel</strong>, <strong>smell</strong>, <strong>taste</strong>, and <strong>seem</strong> describe how things appear or seem to our senses or feelings. They express impressions or states rather than actions.
      </p>


<div className="grammar-explanation-grid">
      <div className="example-block">
        <p><strong>Verb + adjective</strong> — describe a quality or state:</p>
        <ul>
          <li>You <strong>look</strong> tired.</li>
          <li>This soup <strong>tastes</strong> delicious.</li>
          <li>She <strong>seems</strong> happy.</li>
          <li>He <strong>felt</strong> cold after the swim.</li>
        </ul>
      </div>


      <div className="example-block">
        <p><strong>Verb + like + noun</strong> — compare something to another thing:</p>
        <ul>
          <li>You <strong>look like</strong> a teacher.</li>
          <li>This <strong>smells like</strong> garlic.</li>
          <li>He <strong>sounds like</strong> his dad.</li>
        </ul>
      </div>

      <div className="example-block">
        <p><strong>Verb + as if / as though + clause</strong> — describe what a situation seems like:</p>
        <ul>
          <li>She <strong>looks as if</strong> she’s going to cry.</li>
          <li>It <strong>sounds as though</strong> they’re arguing.</li>
          <li>He <strong>acted as if</strong> he didn’t know me.</li>
        </ul>
      </div>
</div>
      
    </div>
  );
};

export default SenseverbsExplanation;
